import React from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";

const apiUrl = process.env.REACT_APP_API_URL;

function StoryTemplate({ page }) {
  const imageClass = page.image_position === "right" ? "image-content1" : "image-content";

  return (
    <>
      <Head />
      {/* Start Breadcrumbs */}
      <section className="ak-about-hero-1">
        <img
          src={page.hero_image ? `${apiUrl}/${page.hero_image}` : "/assets/img/bg/chairman-bg.png"}
          className="about-hero-bg ak-bg object-cover"
          alt="..."
          data-swiper-parallax={1152}
        />
        <div className="container">
          <div className="about-hero-content">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              {page.subtitle && (
                <p className="ak-section-subtitle animation-title" style={{ color: "white !important" }}>
                  {page.subtitle}
                </p>
              )}
              <h2 className="ak-section-title animation-title" style={{ color: "white" }}>
                {page.title}
              </h2>
            </div>
            <a href="/" className="back-btn" style={{ color: "white" }}>
              Home / About / {page.title}
            </a>
          </div>
        </div>
      </section>
      {/* End Breadcrumbs */}
      {/* Start About */}
      <div className="ak-height-125 ak-height-lg-80" />
      <section>
        <div className="about-us-content-bg">
          <div className="container">
            <div className="about-us-content">
              {page.cover_image && (
                <div className={imageClass}>
                  <img className="about-img-1" src={`${apiUrl}/${page.cover_image}`} alt="..." />
                </div>
              )}
              <div className="info-content">
                <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
                  {page.subtitle && <p className="ak-section-subtitle animation-title">{page.subtitle}</p>}
                  {page.heading && <h2 className="ak-section-title animation-title">{page.heading}</h2>}
                  <div className="ak-section-desp" dangerouslySetInnerHTML={{ __html: page.body || "" }} />
                </div>
              </div>
            </div>
            <div className="ak-height-125 ak-height-lg-80" />
          </div>
          <img className="aboutus" src="/assets/img/bg/aboutus.png" alt="..." />
        </div>
      </section>
      {/* End About */}
      <Foot />
    </>
  );
}

export default StoryTemplate;
